import { AccrediblePageMeta } from '@accredible-frontend-v2/models';
import { createReducer, on } from '@ngrx/store';
import { removeEmptyCustomAttributes } from '../../../../core/helpers/profile-processing.helper';
import {
  SpotlightProfile,
  SpotlightProfilesFilters,
} from '../../../../core/models/spotlight-profiles.model';
import { SpotlightProfilesActions } from './spotlight-profiles.actions';

export const spotlightProfilesFeatureKey = 'spotlightProfiles';

export interface SpotlightProfilesState {
  spotlightProfilesPageData: {
    meta: AccrediblePageMeta;
    profiles: SpotlightProfile[];
  };
  filters: SpotlightProfilesFilters;

  action: SpotlightProfilesStateAction;
  payload: any;
  error: any;
}

export enum SpotlightProfilesStateAction {
  NO_ACTION,
  SPOTLIGHT_PROFILES_LOADED,
  FILTERS_RESET,
  HAS_ERROR,
}

const initialStateHandling: Partial<SpotlightProfilesState> = {
  action: SpotlightProfilesStateAction.NO_ACTION,
  payload: null,
  error: null,
};

export const initialState = <SpotlightProfilesState>{
  spotlightProfilesPageData: {
    meta: {
      current_page: 1,
      page_size: 20,
      total_count: 0,
      max_available: 0,
    },
    profiles: [{}, {}, {}],
  },
  filters: null,

  ...initialStateHandling,
};

export const reducer = createReducer(
  initialState,

  on(SpotlightProfilesActions.loadPlaceDetails, (state, { filters }) => ({
    ...state,
    filters: {
      ...state.filters,
      ...filters,
    },
    ...initialStateHandling,
  })),
  on(SpotlightProfilesActions.loadPlaceDetailsSuccess, (state, { filters }) => ({
    ...state,
    filters: {
      ...state.filters,
      ...filters,
    },
    ...initialStateHandling,
  })),
  on(SpotlightProfilesActions.loadPlaceDetailsFailure, (state) => ({
    ...state,
    action: SpotlightProfilesStateAction.HAS_ERROR,
  })),

  on(SpotlightProfilesActions.loadSpotlightProfiles, (state, { filters }) => ({
    ...state,
    filters: {
      ...state.filters,
      ...filters,
    },
    ...initialStateHandling,
  })),
  on(SpotlightProfilesActions.loadSpotlightProfilesSuccess, (state, { meta, profiles }) => ({
    ...state,
    spotlightProfilesPageData: {
      meta: { ...meta },
      profiles: profiles.map((profile) => removeEmptyCustomAttributes(profile)),
    },
    action: SpotlightProfilesStateAction.SPOTLIGHT_PROFILES_LOADED,
  })),
  on(SpotlightProfilesActions.loadSpotlightProfilesFailure, (state) => ({
    ...state,
    action: SpotlightProfilesStateAction.HAS_ERROR,
  })),

  on(SpotlightProfilesActions.clearFilters, () => ({
    ...initialState,
    action: SpotlightProfilesStateAction.FILTERS_RESET,
  })),
);
